module.exports = __webpack_public_path__ + "img/志愿组织.dd450bf2.png";